import { TableColumnMeta } from "ds/components/Table/types";

export const AWS_USED_BY_MANUAL_TABLE_STORAGE_KEY = "awsUsedByManualTableStorageKey";
export const AWS_USED_BY_AUTOATTACHED_TABLE_STORAGE_KEY = "awsUsedByAutoattachedTableStorageKey";
export const AWS_USED_BY_FILTERS_STORAGE_KEY = "awsUsedByFiltersStorageKey";
export const AWS_USED_BY_MANUAL_FILTERS_STORAGE_KEY = "awsUsedByManualFiltersStorageKey";
export const AWS_USED_BY_AUTOATTACHED_FILTERS_STORAGE_KEY =
  "awsUsedByAutoattachedFiltersStorageKey";

export enum USED_BY_COLUMN_ID {
  TYPE = "TYPE",
  NAME = "NAME",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 600;

export const USED_BY_COLUMN_CONFIG: Record<USED_BY_COLUMN_ID, TableColumnMeta> = {
  [USED_BY_COLUMN_ID.TYPE]: {
    id: USED_BY_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 80,
    defaultWidth: 80,
    maxWidth: 80,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    configurable: true,
  },
  [USED_BY_COLUMN_ID.NAME]: {
    id: USED_BY_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    configurable: true,
  },
  [USED_BY_COLUMN_ID.SPACE]: {
    id: USED_BY_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [USED_BY_COLUMN_ID.DROPDOWN]: {
    id: USED_BY_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    noHeader: true,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<USED_BY_COLUMN_ID, string> = {
  [USED_BY_COLUMN_ID.TYPE]: "type",
  [USED_BY_COLUMN_ID.NAME]: "name",
  [USED_BY_COLUMN_ID.SPACE]: "space",
  [USED_BY_COLUMN_ID.DROPDOWN]: "dropdown",
};
